var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxOutlineSlider(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 22.75c-2.75 0-4.75-2-4.75-4.75V6c0-2.75 2-4.75 4.75-4.75h6c2.75 0 4.75 2 4.75 4.75v12c0 2.75-2 4.75-4.75 4.75H9zM5.75 6v12c0 1.62 1 3.25 3.25 3.25h6c2.25 0 3.25-1.63 3.25-3.25V6c0-1.62-1-3.25-3.25-3.25H9C6.75 2.75 5.75 4.38 5.75 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 16.76c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h14c.41 0 .75.34.75.75s-.34.75-.75.75H5zM1.25 20V4c0-.41.34-.75.75-.75s.75.34.75.75v16c0 .41-.34.75-.75.75s-.75-.34-.75-.75zM21.25 20V4c0-.41.34-.75.75-.75s.75.34.75.75v16c0 .41-.34.75-.75.75s-.75-.34-.75-.75z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineSlider);
export default __webpack_public_path__ + "static/media/vuesax-outline-slider.9fba8ef9d52fcf05a7abc7894821a116.svg";
export { ForwardRef as ReactComponent };